module.exports = __webpack_public_path__ + "static/media/unchecked_icon.a06f1eb4.svg";